"use client";
/* Auto-generated. Do not edit. */
/* Source: src/pages/home-modules/home-five/sections/bannerSection.tsx */

import { SmartImage } from "@/Components";
import { SmartLink } from "@/Components";
import { renderCollectionNode, renderItemNode, renderNode } from "@/Templates/section-node-renderers";
import Slider from "react-slick";
import { FC, ComponentProps, Key, ReactNode, useRef } from "react";

type BannerSectionCountersItem = {
    key: Key | null | undefined;
    /** Detected variants: "+" | "%" */
    h20Text: ReactNode;
    /** Detected variants: "10" | "100" | "250" */
    span0Text: ReactNode;
    /** Detected variants: "Years of Experience" | "Satisfaction Rate" | "Certified Doctors" */
    p0Text: ReactNode;
    /** Detected variants: "counter-item" */
    className?: string;
    /** Detected variants: "counter-degit" */
    h20ClassName?: string;
    /** Detected variants: "count" */
    span0ClassName?: string;
};

type BannerSectionFaSolidFaStarsItem = {
    key: Key | null | undefined;
    /** Detected variants: "fa-solid fa-star" */
    className?: string;
};

type BannerSectionAvatarAvatarRoundedsItem = {
    key: Key | null | undefined;
    /** Detected variants: "border border-white" */
    className?: string;
    /** Detected variants: "/Templates/Doccure/img/doctors/doctor-thumb-22.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-23.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-24.jpg" | "/Templates/Doccure/img/doctors/doctor-thumb-25.jpg" */
    src: string;
    /** Detected variants: "avatar avatar-rounded" */
    spanClassName?: string;
    /** Detected variants: "img" */
    alt?: string;
};

type BannerSectionH1sItem = {
    key: Key | null | undefined;
};

type BannerSectionBannerSlidesItem = {
    key: Key | null | undefined;
    /** Detected variants: "/Templates/Doccure/img/banner/banner-img-1.png" | "/Templates/Doccure/img/banner/banner-img-2.png" | "/Templates/Doccure/img/banner/banner-img-3.png" */
    src: string;
    /** Detected variants: "banner-slide" */
    className?: string;
    /** Detected variants: "journey-img" */
    alt?: string;
    /** Detected variants: "img-fluid img-1" */
    imageWithBasePath0ClassName?: string;
};
const settings = {
    dots: false,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    arrows: false, // we control arrows manually
    responsive: [
        {
            breakpoint: 1400,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
        {
            breakpoint: 1200,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
        {
            breakpoint: 992,
            settings: { slidesToShow: 3, slidesToScroll: 1 },
        },
        {
            breakpoint: 768,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
        {
            breakpoint: 576,
            settings: { slidesToShow: 1, slidesToScroll: 1 },
        },
    ],
};

export type HomeFiveBannerSectionGeneratedProps = {
    divDiv0Div0ClassName?: string;
    /** Default: "Comprehensive diagnosis by top ENT specialists." */
    divDiv0Div0Div0Div0Div0Div0DivText?: ReactNode;
    /** Default: "Why Choose Us" */
    divDiv0Div0Div0Div0Div0Div0Span0SpanText?: ReactNode;
    /** Default: "Expert ENT Care for" */
    divDiv0Div0Div0Div0Div0H10H1Text?: ReactNode;
    /** Default: "Your Ear, Nose &" */
    divDiv0Div0Div0Div0Div0H10H1Text2?: ReactNode;
    /** Default: "Throat Health" */
    divDiv0Div0Div0Div0Div0H10H1Text3?: ReactNode;
    divDiv0Div0Div0Div0Div0H10H1Visible?: boolean;
    divDiv0Div0Div0Div0Div0H10H1Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Div0H10H1Props?: Partial<ComponentProps<"h1">>;
    /** Default: "banner-img" */
    divDiv0Div0Div0Div0ImageWithBasePath0ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-4.png" */
    divDiv0Div0Div0Div0ImageWithBasePath0ImageSrc?: string;
    divDiv0Div0Div0Div0ImageWithBasePath0ImageVisible?: boolean;
    divDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0ImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img" */
    divDiv0Div0Div0Div0ImageWithBasePath1ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-5.png" */
    divDiv0Div0Div0Div0ImageWithBasePath1ImageSrc?: string;
    divDiv0Div0Div0Div0ImageWithBasePath1ImageVisible?: boolean;
    divDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0ImageWithBasePath1ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "banner-img" */
    divDiv0Div0Div0Div0ImageWithBasePath2ImageAlt?: string;
    /** Default: "/Templates/Doccure/img/banner/banner-img-6.png" */
    divDiv0Div0Div0Div0ImageWithBasePath2ImageSrc?: string;
    divDiv0Div0Div0Div0ImageWithBasePath2ImageVisible?: boolean;
    divDiv0Div0Div0Div0ImageWithBasePath2ImageRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0ImageWithBasePath2ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>;
    /** Default: "#" */
    divDiv0Div0Div0Div0Link0LinkHref?: string;
    /** Default: "Start Booking" */
    divDiv0Div0Div0Div0Link0LinkText?: ReactNode;
    divDiv0Div0Div0Div0Link0LinkVisible?: boolean;
    divDiv0Div0Div0Div0Link0LinkRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div0Div0Link0LinkProps?: Partial<ComponentProps<typeof SmartLink>>;
    /** Default: "5698+" */
    divDiv0Div0Div1Div0Div0H30H3Text?: ReactNode;
    divDiv0Div0Div1Div0Div0H30H3Visible?: boolean;
    divDiv0Div0Div1Div0Div0H30H3Renderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div1Div0Div0H30H3Props?: Partial<ComponentProps<"h3">>;
    /** Default: "Trusted Patients" */
    divDiv0Div0Div1Div0Div0H30Span0SpanText?: ReactNode;
    divDiv0Div0Div1Div0Div1Button0ButtonVisible?: boolean;
    divDiv0Div0Div1Div0Div1Button0ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div1Div0Div1Button0ButtonProps?: Partial<ComponentProps<"button">>;
    divDiv0Div0Div1Div0Div1Button1ButtonVisible?: boolean;
    divDiv0Div0Div1Div0Div1Button1ButtonRenderer?: (defaultNode: ReactNode) => ReactNode;
    divDiv0Div0Div1Div0Div1Button1ButtonProps?: Partial<ComponentProps<"button">>;
    divDiv0Div0Div1Div0Slider0SliderProps?: Partial<ComponentProps<typeof Slider>>;
    divH20H2Props?: Partial<ComponentProps<"h2">> | ((item: BannerSectionCountersItem) => Partial<ComponentProps<"h2">>);
    divImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionBannerSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    spanImageWithBasePath0ImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionCounters: BannerSectionCountersItem[];
    bannerSectionFaSolidFaStars: BannerSectionFaSolidFaStarsItem[];
    bannerSectionAvatarAvatarRoundeds: BannerSectionAvatarAvatarRoundedsItem[];
    bannerSectionH1s: BannerSectionH1sItem[];
    bannerSectionBannerSlides: BannerSectionBannerSlidesItem[];
    bannerSectionCountersItemWrapper?: (item: BannerSectionCountersItem, content: ReactNode) => ReactNode;
    bannerSectionCountersRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionCountersH2Visible?: boolean;
    bannerSectionCountersH2Renderer?: (item: BannerSectionCountersItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionCountersH2Props?: Partial<ComponentProps<"h2">> | ((item: BannerSectionCountersItem) => Partial<ComponentProps<"h2">>);
    bannerSectionFaSolidFaStarsItemWrapper?: (item: BannerSectionFaSolidFaStarsItem, content: ReactNode) => ReactNode;
    bannerSectionFaSolidFaStarsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsItemWrapper?: (item: BannerSectionAvatarAvatarRoundedsItem, content: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsImageVisible?: boolean;
    bannerSectionAvatarAvatarRoundedsImageRenderer?: (item: BannerSectionAvatarAvatarRoundedsItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionAvatarAvatarRoundedsImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionAvatarAvatarRoundedsItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
    bannerSectionH1sItemWrapper?: (item: BannerSectionH1sItem, content: ReactNode) => ReactNode;
    bannerSectionH1sRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerSlidesItemWrapper?: (item: BannerSectionBannerSlidesItem, content: ReactNode) => ReactNode;
    bannerSectionBannerSlidesRenderer?: (defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerSlidesImageVisible?: boolean;
    bannerSectionBannerSlidesImageRenderer?: (item: BannerSectionBannerSlidesItem, defaultNode: ReactNode) => ReactNode;
    bannerSectionBannerSlidesImageProps?: Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">> | ((item: BannerSectionBannerSlidesItem) => Partial<Omit<ComponentProps<typeof SmartImage>, "src" | "alt" | "cover" | "objectFit">>);
};

const HomeFiveBannerSectionGenerated: FC<HomeFiveBannerSectionGeneratedProps> = ({
    divDiv0Div0Div0Div0Div0Div0DivText = "Comprehensive diagnosis by top ENT specialists.",
    divDiv0Div0Div0Div0Div0Div0Span0SpanText = "Why Choose Us",
    divDiv0Div0Div0Div0Div0H10H1Text = "Expert ENT Care for",
    divDiv0Div0Div0Div0Div0H10H1Text2 = "Your Ear, Nose &",
    divDiv0Div0Div0Div0Div0H10H1Text3 = "Throat Health",
    divDiv0Div0Div0Div0Div0H10H1Visible,
    divDiv0Div0Div0Div0Div0H10H1Renderer,
    divDiv0Div0Div0Div0Div0H10H1Props,
    divDiv0Div0Div0Div0ImageWithBasePath0ImageAlt = "banner-img",
    divDiv0Div0Div0Div0ImageWithBasePath0ImageSrc = "/Templates/Doccure/img/banner/banner-img-4.png",
    divDiv0Div0Div0Div0ImageWithBasePath0ImageVisible,
    divDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer,
    divDiv0Div0Div0Div0ImageWithBasePath0ImageProps,
    divDiv0Div0Div0Div0ImageWithBasePath1ImageAlt = "banner-img",
    divDiv0Div0Div0Div0ImageWithBasePath1ImageSrc = "/Templates/Doccure/img/banner/banner-img-5.png",
    divDiv0Div0Div0Div0ImageWithBasePath1ImageVisible,
    divDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer,
    divDiv0Div0Div0Div0ImageWithBasePath1ImageProps,
    divDiv0Div0Div0Div0ImageWithBasePath2ImageAlt = "banner-img",
    divDiv0Div0Div0Div0ImageWithBasePath2ImageSrc = "/Templates/Doccure/img/banner/banner-img-6.png",
    divDiv0Div0Div0Div0ImageWithBasePath2ImageVisible,
    divDiv0Div0Div0Div0ImageWithBasePath2ImageRenderer,
    divDiv0Div0Div0Div0ImageWithBasePath2ImageProps,
    divDiv0Div0Div0Div0Link0LinkHref = "#",
    divDiv0Div0Div0Div0Link0LinkText = "Start Booking",
    divDiv0Div0Div0Div0Link0LinkVisible,
    divDiv0Div0Div0Div0Link0LinkRenderer,
    divDiv0Div0Div0Div0Link0LinkProps,
    divDiv0Div0Div1Div0Div0H30H3Text = "5698+",
    divDiv0Div0Div1Div0Div0H30H3Visible,
    divDiv0Div0Div1Div0Div0H30H3Renderer,
    divDiv0Div0Div1Div0Div0H30H3Props,
    divDiv0Div0Div1Div0Div0H30Span0SpanText = "Trusted Patients",
    divDiv0Div0Div1Div0Div1Button0ButtonVisible,
    divDiv0Div0Div1Div0Div1Button0ButtonRenderer,
    divDiv0Div0Div1Div0Div1Button0ButtonProps,
    divDiv0Div0Div1Div0Div1Button1ButtonVisible,
    divDiv0Div0Div1Div0Div1Button1ButtonRenderer,
    divDiv0Div0Div1Div0Div1Button1ButtonProps,
    divDiv0Div0Div1Div0Slider0SliderProps,
    divH20H2Props,
    divImageWithBasePath0ImageProps,
    spanImageWithBasePath0ImageProps,
    divDiv0Div0ClassName,
    bannerSectionCounters,
    bannerSectionFaSolidFaStars,
    bannerSectionAvatarAvatarRoundeds,
    bannerSectionH1s,
    bannerSectionBannerSlides,
    bannerSectionCountersItemWrapper,
    bannerSectionCountersRenderer,
    bannerSectionCountersH2Visible,
    bannerSectionCountersH2Renderer,
    bannerSectionCountersH2Props,
    bannerSectionFaSolidFaStarsItemWrapper,
    bannerSectionFaSolidFaStarsRenderer,
    bannerSectionAvatarAvatarRoundedsItemWrapper,
    bannerSectionAvatarAvatarRoundedsRenderer,
    bannerSectionAvatarAvatarRoundedsImageVisible,
    bannerSectionAvatarAvatarRoundedsImageRenderer,
    bannerSectionAvatarAvatarRoundedsImageProps,
    bannerSectionH1sItemWrapper,
    bannerSectionH1sRenderer,
    bannerSectionBannerSlidesItemWrapper,
    bannerSectionBannerSlidesRenderer,
    bannerSectionBannerSlidesImageVisible,
    bannerSectionBannerSlidesImageRenderer,
    bannerSectionBannerSlidesImageProps,
}) => {
    const sliderRef = useRef<Slider | null>(null);
    return (
        <div className="banner-section-five">
            <div className="container-fluid">
                <div className={divDiv0Div0ClassName ?? "row"}>
                    <div className="col-xl-6">
                        <div className="banner-content-five">
                            <div className="section-header section-header-five">
                                <div className="sub-title">
                                    <span>{divDiv0Div0Div0Div0Div0Div0Span0SpanText}</span>
                                    {divDiv0Div0Div0Div0Div0Div0DivText}
                                </div>
                                {renderNode(divDiv0Div0Div0Div0Div0H10H1Visible, divDiv0Div0Div0Div0Div0H10H1Renderer, (
                                    <h1 className="section-title" {...(divDiv0Div0Div0Div0Div0H10H1Props ?? {})}>
                                        {renderCollectionNode(
                                            bannerSectionH1s,
                                            (item: BannerSectionH1sItem) => (
                                                <br key={item.key} />
                                            ),
                                            bannerSectionH1sItemWrapper,
                                            bannerSectionH1sRenderer
                                        )}
                                    </h1>
                                ))}
                            </div>
                            {renderNode(divDiv0Div0Div0Div0Link0LinkVisible, divDiv0Div0Div0Div0Link0LinkRenderer, (
                                <SmartLink href={divDiv0Div0Div0Div0Link0LinkHref} className="btn btn-white d-inline-flex align-items-center gap-2" {...(divDiv0Div0Div0Div0Link0LinkProps ?? {})}>
                                    {divDiv0Div0Div0Div0Link0LinkText}
                                    <i className="isax isax-arrow-right-1" />
                                    {" "}
                                </SmartLink>
                            ))}
                            <div className="banner-five-counter">
                                {renderCollectionNode(
                                    bannerSectionCounters,
                                    (item: BannerSectionCountersItem) => (
                                        <div className={item.className ?? "counter-item"} key={item.key}>
                                            {renderItemNode(bannerSectionCountersH2Visible, bannerSectionCountersH2Renderer, item, (
                                                <h2 className={item.h20ClassName ?? "counter-degit"} {...(typeof bannerSectionCountersH2Props === "function" ? bannerSectionCountersH2Props(item) : (bannerSectionCountersH2Props ?? {}))} {...(typeof divH20H2Props === "function" ? divH20H2Props(item) : (divH20H2Props ?? {}))}>
                                                    <span className={item.span0ClassName ?? "count"}>{item.span0Text}</span>
                                                    {item.h20Text}
                                                </h2>
                                            ))}
                                            <p>{item.p0Text}</p>
                                        </div>
                                    ),
                                    bannerSectionCountersItemWrapper,
                                    bannerSectionCountersRenderer
                                )}
                            </div>
                            {renderNode(divDiv0Div0Div0Div0ImageWithBasePath0ImageVisible, divDiv0Div0Div0Div0ImageWithBasePath0ImageRenderer, (
                                <SmartImage src={divDiv0Div0Div0Div0ImageWithBasePath0ImageSrc} alt={divDiv0Div0Div0Div0ImageWithBasePath0ImageAlt} className="img-fluid img-1" {...(divDiv0Div0Div0Div0ImageWithBasePath0ImageProps ?? {})} />
                            ))}
                            {renderNode(divDiv0Div0Div0Div0ImageWithBasePath1ImageVisible, divDiv0Div0Div0Div0ImageWithBasePath1ImageRenderer, (
                                <SmartImage src={divDiv0Div0Div0Div0ImageWithBasePath1ImageSrc} alt={divDiv0Div0Div0Div0ImageWithBasePath1ImageAlt} className="img-fluid img-2" {...(divDiv0Div0Div0Div0ImageWithBasePath1ImageProps ?? {})} />
                            ))}
                            {renderNode(divDiv0Div0Div0Div0ImageWithBasePath2ImageVisible, divDiv0Div0Div0Div0ImageWithBasePath2ImageRenderer, (
                                <SmartImage src={divDiv0Div0Div0Div0ImageWithBasePath2ImageSrc} alt={divDiv0Div0Div0Div0ImageWithBasePath2ImageAlt} className="img-fluid img-3" {...(divDiv0Div0Div0Div0ImageWithBasePath2ImageProps ?? {})} />
                            ))}
                        </div>
                    </div>
                    <div className="col-xl-6">
                        <div className="banner-content-slide">
                            <Slider ref={sliderRef} className="banner-slider-five" {...settings} {...(divDiv0Div0Div1Div0Slider0SliderProps ?? {})}>
                                {renderCollectionNode(
                                    bannerSectionBannerSlides,
                                    (item: BannerSectionBannerSlidesItem) => (
                                        <div className={item.className ?? "banner-slide"} key={item.key}>
                                            {renderItemNode(bannerSectionBannerSlidesImageVisible, bannerSectionBannerSlidesImageRenderer, item, (
                                                <SmartImage src={item.src} alt={item.alt ?? "journey-img"} className={item.imageWithBasePath0ClassName ?? "img-fluid img-1"} {...(typeof bannerSectionBannerSlidesImageProps === "function" ? bannerSectionBannerSlidesImageProps(item) : (bannerSectionBannerSlidesImageProps ?? {}))} {...(typeof divImageWithBasePath0ImageProps === "function" ? divImageWithBasePath0ImageProps(item) : (divImageWithBasePath0ImageProps ?? {}))} />
                                            ))}
                                        </div>
                                    ),
                                    bannerSectionBannerSlidesItemWrapper,
                                    bannerSectionBannerSlidesRenderer
                                )}
                            </Slider>
                            <div className="banner-review-five">
                                <div className="review">
                                    {renderCollectionNode(
                                        bannerSectionFaSolidFaStars,
                                        (item: BannerSectionFaSolidFaStarsItem) => (
                                            <i className={item.className ?? "fa-solid fa-star"} key={item.key} />
                                        ),
                                        bannerSectionFaSolidFaStarsItemWrapper,
                                        bannerSectionFaSolidFaStarsRenderer
                                    )}
                                </div>
                                {renderNode(divDiv0Div0Div1Div0Div0H30H3Visible, divDiv0Div0Div1Div0Div0H30H3Renderer, (
                                    <h3 {...(divDiv0Div0Div1Div0Div0H30H3Props ?? {})}>
                                        {" "}
                                        {divDiv0Div0Div1Div0Div0H30H3Text}
                                        <span>{divDiv0Div0Div1Div0Div0H30Span0SpanText}</span>
                                        {" "}
                                    </h3>
                                ))}
                                <div className="avatar-list-stacked avatar-group-lg">
                                    {renderCollectionNode(
                                        bannerSectionAvatarAvatarRoundeds,
                                        (item: BannerSectionAvatarAvatarRoundedsItem) => (
                                            <span className={item.spanClassName ?? "avatar avatar-rounded"} key={item.key}>
                                                {renderItemNode(bannerSectionAvatarAvatarRoundedsImageVisible, bannerSectionAvatarAvatarRoundedsImageRenderer, item, (
                                                    <SmartImage className={item.className} src={item.src} alt={item.alt ?? "img"} {...(typeof bannerSectionAvatarAvatarRoundedsImageProps === "function" ? bannerSectionAvatarAvatarRoundedsImageProps(item) : (bannerSectionAvatarAvatarRoundedsImageProps ?? {}))} {...(typeof spanImageWithBasePath0ImageProps === "function" ? spanImageWithBasePath0ImageProps(item) : (spanImageWithBasePath0ImageProps ?? {}))} />
                                                ))}
                                            </span>
                                        ),
                                        bannerSectionAvatarAvatarRoundedsItemWrapper,
                                        bannerSectionAvatarAvatarRoundedsRenderer
                                    )}
                                </div>
                            </div>
                            <div className="slide-btn">
                                {renderNode(divDiv0Div0Div1Div0Div1Button0ButtonVisible, divDiv0Div0Div1Div0Div1Button0ButtonRenderer, (
                                    <button type="button" className="slick-arrow ban-prev" {...(divDiv0Div0Div1Div0Div1Button0ButtonProps ?? {})}>
                                        <i className="isax isax-arrow-left" />
                                    </button>
                                ))}
                                {renderNode(divDiv0Div0Div1Div0Div1Button1ButtonVisible, divDiv0Div0Div1Div0Div1Button1ButtonRenderer, (
                                    <button type="button" className="slick-arrow ban-next" {...(divDiv0Div0Div1Div0Div1Button1ButtonProps ?? {})}>
                                        <i className="isax isax-arrow-right-1" />
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeFiveBannerSectionGenerated;
